import { getBrowserApiBaseUrl } from '@/config/env'
import { getAuthTokenFromStorage } from '@/lib/utils/storage'
import type { PaymentLogDetailSource } from '../types/api'

/** Receipt / adjustment export URLs (Angular `report-paymentlogs-detail`). */
export function buildPaymentLogExportUrls(
  id: string,
  source: PaymentLogDetailSource = 'payment_log',
): { downloadUrl: string; printUrl: string } {
  const token = getAuthTokenFromStorage()
  if (!token) {
    return { downloadUrl: '', printUrl: '' }
  }
  const base = getBrowserApiBaseUrl()
  const p = new URLSearchParams()
  p.set('access_token', token)

  if (source === 'payment_adjustment') {
    const path = `${base}/api/payment_adjustment/${id}`
    const query = p.toString()
    return {
      downloadUrl: `${path}?${query}&download=true`,
      printUrl: `${path}?${query}&print=true`,
    }
  }

  const path = `${base}/api/export/payment_receipt/${id}`
  const query = p.toString()
  return {
    downloadUrl: `${path}?${query}`,
    printUrl: `${path}?${query}&print=true`,
  }
}
